const weiqing = '../addons/citygf/template/mobile';
const temUrl = 'kpfs/2020/invention_exhibition';
const rootUrl = `${weiqing}/${temUrl}`;
const localStorageId = 'kpfs-invention_exhibition';
const weOrSzyw = 'http://we.citygf.com/kpfs';
const link = 'http://we.citygf.com/kpfs/app/index.php?c=entry&m=citygf&do=indexnew&j=12&i=12&rid=9001267';
const [isVConsole, isDevTool, isQrcode] = [false, false, true];
// const rootUrl = "/images/2018zt/wx/yxh5";

const distName = 'dist';

const webUrl = '../../../../';

const cdn = {
  css: [
    '//cdn.jsdelivr.net/npm/weui@2.3.0',
    '//www.foshannews.net/js/reset-and3.min.css',
    '//cdn.jsdelivr.net/npm/animate.css@3.7.2/animate.min.css',
  ],
  js: [
    '//cdn.jsdelivr.net/npm/hotcss@2.2.1/src/hotcss.min.js',
    '//cdn.jsdelivr.net/npm/weui.js@1.2.1/dist/weui.min.js',
    '//cstaticdun.126.net/load.min.js',

    '//cdn.jsdelivr.net/npm/vue@2.6.11/dist/vue.min.js',
    '//cdn.jsdelivr.net/npm/vue-router@3.1.5/dist/vue-router.min.js',
    '//cdn.jsdelivr.net/npm/axios@0.19.2/dist/axios.min.js',
    '//cdn.jsdelivr.net/npm/sweetalert@2.1.2/dist/sweetalert.min.js',
    '//cdn.jsdelivr.net/npm/jsencrypt@2.3.1/bin/jsencrypt.min.js',
  ],
  externals: {
    vue: 'Vue',
    swal: 'swal',
    weui: 'weui',
    axios: 'axios',
    initNECaptcha: 'initNECaptcha',
    VueRouter: 'VueRouter',
    hotcss: 'hotcss',
    // FastClick: 'FastClick',
    // PIXI: 'PIXI',
    // 'pixi.js': 'PIXI',
    // TweenMax: 'TweenMax',
    // TimelineMax: 'TimelineMax',
    // AlloyTouch: 'AlloyTouch',
    // initNECaptcha: 'initNECaptcha',
    // createjs: 'createjs',
  },
};

module.exports = {
  rootUrl,
  distName,
  webUrl,
  localStorageId,
  weOrSzyw,
  cdn,
  isDevTool,
  isVConsole,
  link,
  isQrcode,
};
